import React, { useEffect, useMemo, useState } from 'react'
import { Image, TouchableOpacity, useWindowDimensions, ImageStyle, StyleProp } from 'react-native'

const logoLarge = require('../ResponsiveLogo/logo.jpg')
const logoSmall  = require('../ResponsiveLogo/logo2.jpg')

type Variant = {
  src: any
  width: number
  height: number
}

interface ResponsiveLogoProps {
  onPress?: () => void
  breakpoint?: number
  hysteresis?: number
  large?: Partial<Variant>
  small?: Partial<Variant>
  style?: StyleProp<ImageStyle>
}

const DEFAULT_BREAKPOINT = 800
const DEFAULT_HYST = 16

const ResponsiveLogo: React.FC<ResponsiveLogoProps> = ({
  onPress,
  breakpoint = DEFAULT_BREAKPOINT,
  hysteresis = DEFAULT_HYST,
  large,
  small,
  style,
}) => {
  const { width } = useWindowDimensions()

  const largeCfg: Variant = {
    src: logoLarge,
    width: 700,
    height: 100,
    ...large,
  }
  const smallCfg: Variant = {
    src: logoSmall,
    width: 370,
    height: 50,
    ...small,
  }

  const [isWide, setIsWide] = useState(width > breakpoint)

  useEffect(() => {
    if (isWide && width < breakpoint - hysteresis) setIsWide(false)
    if (!isWide && width > breakpoint + hysteresis) setIsWide(true)
  }, [width, isWide, breakpoint, hysteresis])

  const source = useMemo(() => (isWide ? largeCfg.src : smallCfg.src), [isWide, largeCfg.src, smallCfg.src])

  const imgStyle = useMemo(
    () => [{ width: isWide ? largeCfg.width : smallCfg.width, height: isWide ? largeCfg.height : smallCfg.height }, style],
    [isWide, largeCfg.width, largeCfg.height, smallCfg.width, smallCfg.height, style]
  )

  return (
      <Image source={source} style={imgStyle} />
  )
}

export default ResponsiveLogo
